import {useMemo} from 'react'
import {isContextDiffLine} from '../helpers/line-helpers'
import type {DiffLineWithSelectionInfo} from '../types'
import {useGetSelectedLineRange} from '../stores/selectors'

export function useCommentDialogTitle(
  diffLine: DiffLineWithSelectionInfo,
  isLeftSide: boolean,
  isLineSelected: boolean,
) {
  const getSelectedLineRange = useGetSelectedLineRange()
  return useMemo(() => {
    const selectedLineRage = getSelectedLineRange()
    let text = ''
    const isMultiLineComment: boolean =
      !!selectedLineRage && selectedLineRage.startLineNumber !== selectedLineRage.endLineNumber

    if (selectedLineRage && isMultiLineComment && isLineSelected) {
      const lineSideIdentifier = {
        left: 'L',
        right: 'R',
      }
      const startSideIdentifier = lineSideIdentifier[selectedLineRage.startOrientation]
      const endSideIdentifier = lineSideIdentifier[selectedLineRage.endOrientation]
      const isMultiLineSelection = selectedLineRage.startLineNumber !== selectedLineRage.endLineNumber

      text += isMultiLineSelection
        ? ` lines ${startSideIdentifier}${selectedLineRage.startLineNumber} to ${endSideIdentifier}${selectedLineRage.endLineNumber}`
        : ` line ${startSideIdentifier}${selectedLineRage.startLineNumber}`
    } else {
      const sideIdentifier = isLeftSide && !isContextDiffLine(diffLine) ? 'L' : 'R'
      text += ` line ${sideIdentifier}${diffLine.blobLineNumber}`
    }

    return text
  }, [diffLine, getSelectedLineRange, isLeftSide, isLineSelected])
}
